<div class="col-md-12 mt-4">
    <hr/>
    <h5>Referencia Personales</h5>
</div>
<div class="row" [formGroup]="form">
    <div formArrayName="references" *ngFor="let item of getControls(); index as i" class="row">
        <div class="col-md-12 mt-4">
            <h6>Referencia {{i+1}}<button *ngIf="i > 1"class="btn btn-danger" type="button" style="float: right" (click)="removeRow(i)">X </button></h6>
        </div>
        <div class="col-md-6" *ngFor="let field of formFields" [formGroupName]="i">
            <label class="form-labels mt-4">{{field.title}}</label>
            <div class="input-group">
                <input *ngIf="field.type != 'tel'" [type]="field.type" [formControlName]="field.formControlName" class="form-control">
                <input *ngIf="field.type == 'tel'" [type]="field.type" [formControlName]="field.formControlName" class="form-control" [brmasker]="{mask: '(000) 000-0000', type:'num'}" maxlength="14">
            </div>
        </div>
    </div>
</div>

<p style="text-align: center;">
<a (click)="addItem()" style="max-width: 150px;" class="btn btn-primary mt-4">+ Añadir Referencia</a>
</p>